import { render, staticRenderFns } from "./UseCultivistCardAction.vue?vue&type=template&id=32dce60c&scoped=true&"
import script from "./UseCultivistCardAction.vue?vue&type=script&lang=ts&"
export * from "./UseCultivistCardAction.vue?vue&type=script&lang=ts&"
import style0 from "./UseCultivistCardAction.vue?vue&type=style&index=0&id=32dce60c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dce60c",
  null
  
)

export default component.exports